import type { z } from 'zod';

import { EntitySchema } from './entities.schema';

export const EntityFormSchema = EntitySchema.pick({
  name: true,
  description: true,
  type: true,
  config: true,
});

export type EntityFormData = z.infer<typeof EntityFormSchema>;
export type EntitySchemaProps = z.input<typeof EntityFormSchema>;
export type EntityFormProps = z.output<typeof EntityFormSchema>;
